import React from "react";
import { Layout, InlineStack, TextField, Text } from "@shopify/polaris";

import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import { Toast } from "lib/components";

// import validate from "./yup";

const MoneyMetaData = (props) => {
  const { inputValue, handleChange, metafield, moneyFormat } = props;

  const {
    value: { MIN_PRICE = 0, MAX_FLAT = 99999999 },
  } = constant;

  const acceptOnlyValidInput = (val, prevValue, max = MAX_FLAT) => {
    if (parseFloat(val) > MIN_PRICE && parseFloat(val) < max) {
      return (baseHelper.validatePositiveNumericValues(val) && val) || (val !== "" && prevValue) || "";
    }
    if (!val) {
      return "";
    }
    return prevValue;
  };

  return (
    <>
      <Text>{`${metafield.name} ${metafield.isRequired ? "*" : ""}`}</Text>
      <InlineStack align="space-evenly">
        <TextField
          value={inputValue[metafield.key] || ""}
          onChange={(value) => handleChange(metafield.key, acceptOnlyValidInput(value), "", "", metafield.contentType)}
          prefix={moneyFormat || ""}
        />
      </InlineStack>
    </>
  );
};

export default MoneyMetaData;
